import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../../core/core.module';
import { FunnelHistoryComponent } from './funnel-history/funnel-history.component';
import { QuotationPrintComponent } from './quotation-print/quotation-print.component';
import { Ng2SmartTableLabelComponent } from './ng2-smart-table-label/ng2-smart-table-label.component';
import { JwBootstrapSwitchNg2Module } from 'jw-bootstrap-switch-ng2';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [FunnelHistoryComponent, QuotationPrintComponent, Ng2SmartTableLabelComponent],
  imports: [CommonModule, CoreModule, JwBootstrapSwitchNg2Module, FormsModule],
  exports: [FunnelHistoryComponent, QuotationPrintComponent, Ng2SmartTableLabelComponent],
  entryComponents: [FunnelHistoryComponent, Ng2SmartTableLabelComponent],
})
export class SharedCrmModule {}
